import { tv } from '@/common/theme/tv.config';

export const styles = {
  root: tv({
    base: '',
    variants: {
      size: {
        sm: 'h-[6.4rem]',
        md: 'h-[7.2rem]',
      },
    },
  }),
  input: tv({
    base: 'h-[7.2rem] px-0 pb-[1.2rem] pt-[3rem] text-3xl',
    variants: {
      size: {
        sm: 'h-[6.4rem] text-md',
        md: '',
      },
    },
  }),
};
